import "../style/dashboard/MyExamList.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { GoPrimitiveDot } from "react-icons/go";
import calendar_icon from "../../assets/dashboard/exam-list/stickynote.svg";
import { BsClock } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "jalali-moment";



const MyExamList = () => {
  const state = useSelector((state) => state.default);
  //create suitable data list with main data----------------------------------------------------
  let d = new Date();
  console.log("today:"+d);
  let d_day = d.getDay();
  console.log("today_day:"+d_day);
  let LastDayWeekDate=d;
  switch (d_day) {
    case 1:
      LastDayWeekDate.setDate(d.getDate() + 4);
      break;
    case 2:
      LastDayWeekDate.setDate(d.getDate() + 3);
      break;
    case 3:
      LastDayWeekDate.setDate(d.getDate() + 2);
      break;
    case 4:
      LastDayWeekDate.setDate(d.getDate() + 1);
      break;
    case 6:
      LastDayWeekDate.setDate(d.getDate() + 6);
      break;
    case 7:
      LastDayWeekDate.setDate(d.getDate() + 5);
      break;
    default:
      LastDayWeekDate=d
      break;
  }
  let my_exam_list_data2 = [
    {
      id: 1,
      tab_name: "همه",
      isActive: true,
      tab_content: []
    },
    {
      id: 2,
      tab_name: "آزمون‌های این هفته",
      isActive: false,
      tab_content: []
    },
    {
      id: 3,
      tab_name: "آزمون‌های آینده",
      isActive: false,
      tab_content: []
    },
    {
      id: 4,
      tab_name: "آزمون‌های در حال برگزاری",
      isActive: false,
      tab_content: []
    },
  ]
  for(let b=0;b<state.ExamData.length;b++){
    if(b<8){
      let date = new Date(state.ExamData[b].date);
      let TabType = 1;
      console.log(date);
      let endDate = new Date(state.ExamData[b].endDate);
      if(date<LastDayWeekDate){
        TabType = 1;
        my_exam_list_data2[1].tab_content.push({...state.ExamData[b],tabType:1,sub_id:2});
      }
      else if(date>LastDayWeekDate){
        TabType = 2;
        my_exam_list_data2[2].tab_content.push({...state.ExamData[b],tabType:2,sub_id:3});
      }
      let D = new Date();
      if(D>date && D<endDate){
        TabType = 3;
        my_exam_list_data2[3].tab_content.push({...state.ExamData[b],tabType:3,sub_id:4});
      }
      my_exam_list_data2[0].tab_content.push({...state.ExamData[b],sub_id:1,tabType:TabType});
    }   
  }
  console.log(my_exam_list_data2);
  const [data, set_data] = useState(my_exam_list_data2);
  //------------------------------------------------------
  //cover style list  ------------------------------------
  let coverStyleList=[
    {
      background:"linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 60%)",
    },
    {
      background:"linear-gradient(0deg, rgba(0,70,26,1) 0%, rgba(114,255,180,0) 60%)",
    },
    {
      background:"linear-gradient(0deg, rgba(206,206,28,1) 0%, rgba(255,255,114,0) 60%)",
    },
  ]
  let underCoverStyleList=[
    {
      background:"#72B1FF",
      opacity:0.5
    },
    {
      background:"#72FFB4",
      opacity:0.5
    },
    {
      background:"#FFFF72",
      opacity:0.5
    },
  ]
  //-----------------------------------------------------------
  const [old_tab_id, set_old_tab_id] = useState(1);

  useEffect(() => {
    // console.log("render---------------");
    document.querySelector(".melc-content-item").style.right = `0px`;
  });

  const change_tab = (id) => {
    let new_data = data.map((item) => {
      if (item.id === old_tab_id) {
        item.isActive = false;
      }
      if (item.id === id) {
        item.isActive = true;
      }
      return { ...item };
    });
    // console.log(new_data);
    set_data(new_data);
    set_old_tab_id(id);
    // console.log(old_tab_id);
  };

  let i = 0;
  let max_i;
  for (let j = 0; j < data.length; j++) {
    // console.log(data[j].isActive);
    if (data[j].isActive) {
      max_i = (data[j].tab_content.length - 3) * -1;
      // console.log(max_i);
    }
  }

  // const state = useSelector((state) => state.default);

  if (state.openNav === "open") {
    max_i--;
    if (window.innerWidth < 1360) {
      let tab_name_item = document.querySelectorAll(".melc-h-tab-name-item");
      for (let p = 0; p < tab_name_item.length; p++) {
        tab_name_item[p].style.fontSize = "15px";
      }
    }
    if (window.innerWidth < 1305) {
      let tab_name_item = document.querySelectorAll(".melc-h-tab-name-item");
      for (let p = 0; p < tab_name_item.length; p++) {
        tab_name_item[p].style.fontSize = "13px";
      }
    }
    if (window.innerWidth < 1212) {
      let tab_name_item = document.querySelectorAll(".melc-h-tab-name-item");
      for (let p = 0; p < tab_name_item.length; p++) {
        tab_name_item[p].style.fontSize = "11px";
      }
    }
  }
  if (window.innerWidth < 1536) {
    max_i--;
  }
  if (window.innerWidth < 1170) {
    max_i--;
  }

  const move_left = () => {
    if (i > max_i) {
      i--;
      let movment = i * 245;
      document.querySelector(".melc-content-item").style.right = `${movment}px`;
    }
  };

  const move_right = () => {
    if (i < 0) {
      i++;
      let movment = i * 245;
      document.querySelector(".melc-content-item").style.right = `${movment}px`;
    }
  };
  let s = 0;
  const item_active_hover = (id, sub_id) => {
    // console.log(id,sub_id);
    // s = 0;
    let ss = 0;
    for (let k = 0; k < data.length; k++) {
      s = 0;
      for (let v = 0; v < data[k].tab_content.length; v++) {
        // console.log(data[k].tab_content[v])
        s++;
        if (
          data[k].tab_content[v].id === id &&
          data[k].tab_content[v].sub_id === sub_id
        ) {
          ss = 1;
          break;
        }
      }
      if (ss) {
        break;
      }
    }
    // console.log(s);
    document.querySelectorAll(".melc-c-i-i-under-cover")[
      s - 1
    ].style.transform = "scaleY(1)";
    document
      .querySelectorAll(".melc-c-i-i-info-descriptin")
      [s - 1].classList.add("descript_is_active");
    // document.querySelectorAll(".melc-c-i-i-info-descriptin")[s-1].style.transform="scaleY(1)";
    // console.log(e.target.previousElementSibling);
    //این روش پایدار نیست
    // if(e.target.previousElementSibling !=null){
    //   e.target.previousElementSibling.style.transform="scaleY(1)";
    // }
  };

  const item_deactive_hover = (id, sub_id) => {
    if (s > 0) {
      document.querySelectorAll(".melc-c-i-i-under-cover")[
        s - 1
      ].style.transform = "scaleY(0)";
      document
        .querySelectorAll(".melc-c-i-i-info-descriptin")
        [s - 1].classList.remove("descript_is_active");
    }
    // if(e.target.previousElementSibling !=null){
    //   e.target.previousElementSibling.style.transform="scaleY(0)";
    // }
  };

  moment.locale("en");

  return (
    <div className="my-exam-list">
      <div className="my-exam-list-title">لیست آزمون‌های من</div>
      <div className="my-exam-list-content">
        <div className="melc-header">
          {data.map((item, i) => (
            <div
              style={item.isActive ? { color: "#2E81E8" } : null}
              key={item.id || i}
              className="melc-h-tab-name-item"
              onClick={() => change_tab(item.id)}
            >
              {item.tab_name}
              {item.isActive && (
                <div className="melc-h-tab-name-item-line"></div>
              )}
            </div>
          ))}
          <div className="melc-h-move-btns">
            <IoIosArrowBack onClick={move_left} />
            <IoIosArrowForward onClick={move_right} />
          </div>
        </div>
        <div className="melc-content">
          {data.map((item) => (
            <div key={item.id}>
              {item.isActive && (
                <div className="melc-content-item">
                  {item.isActive &&
                    item.tab_content.map((item) => (
                      <Link to={`/dashboard/azmoon_list/enter_exam/${item.id}`}
                        key={item.id}
                        className="melc-content-i-item"
                        onMouseEnter={() =>
                          item_active_hover(item.id, item.sub_id)
                        }
                        onMouseLeave={() =>
                          item_deactive_hover(item.id, item.sub_id)
                        }
                      >
                        <img
                          className="melc-c-i-i-bg"
                          src={item.img}
                          alt="azmoon-img"
                        />
                        {item.exam_started && (
                          <div className="melc-c-i-i-exam-sit">
                            <GoPrimitiveDot className="melc-c-i-i-exam-sit-icon" />
                            <div className="melc-c-i-i-exam-sit-text">
                              در حال برگزاری
                            </div>
                          </div>
                        )}
                        <div
                          style={underCoverStyleList[item.tabType-1]}
                          className="melc-c-i-i-under-cover"
                        ></div>
                        <div
                          style={coverStyleList[item.tabType-1]}
                          className="melc-c-i-i-cover"
                        ></div>
                        <div className="melc-c-i-item-info">
                          <div className="melc-c-i-i-info-title">
                            <img src={calendar_icon} alt="calendar-icon" />
                            {item.name}
                          </div>
                          <div className="melc-c-i-i-info-line"></div>
                          <div className="melc-c-i-i-info-date-time">
                            <div className="melc-ciiidt-date-container">
                              <BsClock className="melc-clock-icon" />
                              <div className="melc-ciiidt-date">
                                {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                              </div>
                            </div>
                            <div className="melc-ciiidt-time">
                              ساعت {item.time}
                            </div>
                          </div>
                          <div className="melc-c-i-i-info-descriptin">
                            {item.descripton}
                          </div>
                        </div>
                      </Link>
                    ))}
                  <Link
                    to="/dashboard/azmoon_list"
                    className="melc-content-item-more"
                  >
                    مشاهده بیشتر
                  </Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyExamList;
